module.exports = __webpack_public_path__ + "img/esg-1-icon-2.8029891d.svg";